import type { IconProps } from '@epilot/concorde-elements'
import { Icon } from '@epilot/concorde-elements'
import { clsx, type IconConfig } from '@epilot/journey-logic-commons'

import classes from './IconLabel.module.scss'

type IconLabelProps = {
  label: string
  iconConfig?: IconConfig | null
  isRadio?: boolean
  className?: string
}

export function IconLabel({
  label,
  iconConfig,
  isRadio = false,
  className
}: IconLabelProps) {
  const size = `${iconConfig?.settings?.size || 20}px`

  const IconComponent = iconConfig && iconConfig?.name && (
    <Icon
      isFilled={iconConfig.settings?.fill}
      name={iconConfig.name as IconProps['name']}
      size={size}
      variant={iconConfig.settings?.variant}
    />
  )

  return (
    <div className={clsx(classes.spacing, isRadio && classes.radio, className)}>
      {IconComponent}
      {label}
    </div>
  )
}
